import * as ethers from "ethers";
import abi from "../cimer-abi.json";

const cimerContract = process.env.REACT_APP_EXP_CREST_CONTRACT;
const rpc =process.env.REACT_APP_RPC_CARD_PROVIDER;

let provider;
export const rpcProvider = () => {
  if (provider === undefined) {
    return (provider = new ethers.providers.JsonRpcProvider(rpc));
  } else return provider;
};

const contract = new ethers.Contract(cimerContract, abi.abi, rpcProvider());

export const getBalance = async (address) => {
  const balanceOfUser = await contract.balanceOf(address).then().catch();
  //console.log(balanceOfUser, "balance of");
  const balanceOf = balanceOfUser.toNumber();
  return balanceOf;
};

export const getTokenOfOwner = async (owner, index) => {
  const tokenOfOwner = await contract
    .tokenOfOwnerByIndex(owner, index)
    .then()
    .catch();
  //console.log(tokenOfOwner, "token of owner");
  return tokenOfOwner;
};

export const getTokenUri = async (tokenIndex) => {
  const tokenUri = await contract.tokenURI(tokenIndex).then().catch();
  return tokenUri;
};

export const getTokenDna = async (tokenDna) => {
  const dna = await contract.tokenDna(tokenDna).then().catch();
  console.log(dna, "dna");
  return dna;
};
